import { createContext, useContext } from "react";
import type { ArtisanSync } from "./use-artisan-sync";

/**
 * The one folder watcher the application runs (US-05.5).
 *
 * <p>One, and not one per screen: the header shows its state, the settings page drives it and the
 * batch card mentions it, and three independent watchers would upload every roast three times.
 */
export const ArtisanSyncContext = createContext<ArtisanSync | null>(null);

/** @returns the watcher, or null outside the app shell (the sign-in screens render without it) */
export function useArtisanSyncContext(): ArtisanSync | null {
  return useContext(ArtisanSyncContext);
}
